export default "__VITE_ASSET__DECJRB_r__"